import {
  getBeefVisualNoiceList, addBeefVisualNoice, updateBeefVisualNoice, getBeefVisualPersonList, getBeefVisualCommentList, getBeefVisualPersonStatisticsList, deleteBeefVisualComment,
  getBeefVisualAdvanceRecordList
} from '@/api/visual'

const visual = {
  state: {
    total: 0,
    rows: [],
    totaltime: 0
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_TOTALTIME: (state, totaltime) => {
      state.totaltime = totaltime
    }
    // SET_ASSEMBLYLIST: (state, list) => {
    //   state.assemblyList = list
    // },
    // SET_QUANTITY: (state, quantity) => {
    //   state.quantity = quantity
    // },
    // SET_EXPORTERS: (state, exporters) => {
    //   state.exporters = exporters
    // },
    // SET_REVIEWS: (state, reviews) => {
    //   state.reviews = reviews
    // },
    // SET_CHATTOTAL: (state, total) => {
    //   state.chatTotal = total
    // },
    // SET_CHATROWS: (state, rows) => {
    //   state.chatRows = rows
    // }
  },
  actions: {
    GetBeefVisualNoiceList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefVisualNoiceList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddBeefVisualNoice({ commit }, params) {
      return new Promise((resolve, reject) => {
        addBeefVisualNoice(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateBeefVisualNoice({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBeefVisualNoice(params).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBeefVisualPersonList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefVisualPersonList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBeefVisualCommentList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefVisualCommentList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBeefVisualPersonStatisticsList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefVisualPersonStatisticsList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTALTIME', response.Data.TotalTime)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteBeefVisualComment({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteBeefVisualComment(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBeefVisualAdvanceRecordList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefVisualAdvanceRecordList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}
export default visual



// WEBPACK FOOTER //
// ./src/store/modules/visual.js